import {
  NANKAI_LINE_STATIONS,
  KOUYA_LINE_STATIONS,
  TRAIN_KINDS,
  NANKAI_TRAIN_KINDS,
  KOYA_TRAIN_KINDS,
  NANKAI_DESTINATION_STATIONS,
  KOYA_DESTINATION_STATIONS,
  SPECIAL_TRAIN_CARS,
  OTHER_APP_LINKS,
  TIME_TABLE_LINKS,
  KASHIRA_TRAIN_CARS,
} from '../constants'

class MasterData {
  // 駅に関するデータを取得
  static allStations = () => ({...NANKAI_LINE_STATIONS, ...KOUYA_LINE_STATIONS})
  static stationById = stationId => MasterData.allStations()[stationId.toString()]
  static isOnNankaiLine = stationId => !!NANKAI_LINE_STATIONS[stationId]
  static isOnKoyaLine = stationId => !!KOUYA_LINE_STATIONS[stationId]
  static lineIdByLineName = lineName => lineName === 'nankai' ? 1 : 2
  static lineIdByBranchLineName = lineName => lineName === 'nankai' ? 3 : 4
  static UP_EDGE_STATION_IDS = ["1", "61", "84", "95", "137"] // 南海線-難波, 高師浜線-羽衣, 多奈川線-みさき公園, 高野線-難波, 汐見橋線-汐見橋
  static DOWN_EDGE_STATION_IDS = ["42", "63", "77", "81", "94", "136", "142", "156"] // 南海線-和歌山港, 高師浜線-高師浜, 空港線-関西空港, 多奈川線-多奈川, 加太線-加太, 高野線-極楽橋, 汐見橋線-岸里玉出, 泉北高速線-和泉中央
  static SHIOMIBASHI_STATION_IDS = ["137", "138", "139", "140", "141", "142"] // 汐見橋線
  static SHIOMIBASHI_AB_TRAIN_NUMBERS = ["50", "51"] // 汐見橋線の列車番号上2桁

  static stationKind = stationId => {
    const station = MasterData.stationById(stationId)
    return station ? station.kind : null
  }

  static lineKind = stationId => {
    const station = MasterData.stationById(stationId)
    return station ? station.lineKind : null
  }

  static lineSignal = stationId => {
    const station = MasterData.stationById(stationId)
    return station ? station.signal : null
  }

  static lineSwitch = stationId => {
    const station = MasterData.stationById(stationId)
    return station ? station.lineSwitch : null
  }

  static stationNameUrl = stationId => {
    const station = MasterData.stationById(stationId)
    return station ? station.name : null
  }

  // 列車種別に関するデータを取得
  static trainKindById = trainKindId => TRAIN_KINDS[trainKindId.toString()]

  static trainKindByLineIdAndTrainNumber = (lineId, trainNumber) => {
    if (trainNumber.length == 4) {
      trainNumber = trainNumber.substr(0, 2)
    }

    return TRAIN_KINDS[`${lineId}${trainNumber}`]
  }

  // 南海線列車種別に関するデータを取得
  static nankaiTrainKindById = nankaiTrainKindId => NANKAI_TRAIN_KINDS[nankaiTrainKindId.toString()]

  // 高野線列車種別に関するデータを取得
  static koyaTrainKindById = koyaTrainKindId => KOYA_TRAIN_KINDS[koyaTrainKindId.toString()]

  // 南海線行き先に関するデータを取得
  static nankaiDestinationById = nankaiDestinationId => NANKAI_DESTINATION_STATIONS[nankaiDestinationId.toString()]

  // 高野線行き先に関するデータを取得
  static koyaDestinationById = (train) => {
    const id = train.destination_station_id.toString()
    const direction = train.direction
    const trainNumber = train.train_number

    // 信号場が行先の場合変更(駅ID 34: 小原田信号場, 25: 千代田信号場) 
    if (direction == "down") {
      if (id == "34") {
        return KOYA_DESTINATION_STATIONS["32"]
      } else if (id == "25") {
        return KOYA_DESTINATION_STATIONS["24"]
      }
    } else if (direction == "up") {
      if (id == "34") {
        return KOYA_DESTINATION_STATIONS["35"]
      } else if (id == "25") {
        return KOYA_DESTINATION_STATIONS["26"]
      }

      // 列車番号(AB桁)が54,55かつ行先が堺東(駅コード 12)の場合中百舌鳥に変更
      const ab = trainNumber.substring(0, 2)
      if (["54", "55"].includes(ab) && id == "12") {
        return KOYA_DESTINATION_STATIONS["15"]
      }
    }

    return KOYA_DESTINATION_STATIONS[id]
  }

  // 始発の駅かどうかを返す
  static isUpEdgeStation = stationId => MasterData.UP_EDGE_STATION_IDS.includes(stationId)

  // 終着の駅かどうかを返す
  static isDownEdgeStation = stationId => MasterData.DOWN_EDGE_STATION_IDS.includes(stationId)

  // 特別車両に関するデータを取得
  static specialTrainCarsByCarNumber = carNumber => {
    for (const index in SPECIAL_TRAIN_CARS) {
      if (SPECIAL_TRAIN_CARS[index].car_number == carNumber) {
        return SPECIAL_TRAIN_CARS[index]
      }
    }

    return null
  }

  // めでたいでんしゃ かしらに関するデータを取得
  static kashiraTrainCarsByCarNumber = carNumber => {
    for (const index in KASHIRA_TRAIN_CARS) {
      if (KASHIRA_TRAIN_CARS[index].car_number == carNumber) {
        return KASHIRA_TRAIN_CARS[index]
      }
    }

    return null
  }

  // 汐見橋線の駅かどうか返す
  static isShiomibashiStation = stationId => MasterData.SHIOMIBASHI_STATION_IDS.includes(stationId)

  // 汐見橋線の列車かどうか返す
  static isShiomibashiTrain = trainNumber => {
    const ab = trainNumber.substring(0, 2)
    return MasterData.SHIOMIBASHI_AB_TRAIN_NUMBERS.includes(ab)
  }

  // 他社アプリ連携リンク取得
  static getOtherAppLink = (stationId, transferName) => {
    return OTHER_APP_LINKS.find(l => l.station_id === stationId && l.transfer === transferName)
  }

  // 時刻表リンク
  static getTimeTableLink = (stationId, direction) => {
    return TIME_TABLE_LINKS.find(l => l.station_id == stationId && l.direction === direction)
  }
}
export default MasterData
